<template>
  <div class="page trips-select">
    <h1>Selecteer ritten</h1>
  </div>
</template>

<script>
export default {
name: "TripsSelect"
}
</script>
